import React from "react";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";

export default function ServiceCard({ service, index = 0 }) {
  const Icon = service.icon;
  return (
    <motion.div
      data-testid={`service-card-${service.slug}`}
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.7, delay: index * 0.06, ease: [0.16, 1, 0.3, 1] }}
      className="group relative bg-white border border-black/10 hover-lift hover:border-[#C9A86A] hover:shadow-[0_24px_60px_-30px_rgba(0,0,0,0.18)] p-8 md:p-10"
    >
      <div className="img-zoom-wrap aspect-[4/3] mb-7 -mx-8 md:-mx-10 -mt-8 md:-mt-10">
        <img src={service.image} alt={service.title} className="w-full h-full object-cover" loading="lazy" />
      </div>
      <div className="flex items-center gap-3 text-[#B8965A]">
        <Icon className="w-5 h-5" strokeWidth={1.4} />
        <span className="text-[11px] uppercase tracking-[0.24em]">Service</span>
      </div>
      <h3 className="font-display-bold text-2xl md:text-[28px] tracking-tight mt-4 text-[#0A0A0A]">
        {service.title}
      </h3>
      <p className="mt-4 text-[15px] leading-relaxed text-[#525252]">
        {service.short}
      </p>
      <Link
        to="/services"
        data-testid={`service-card-cta-${service.slug}`}
        className="mt-7 inline-flex items-center gap-2 text-[12px] tracking-[0.22em] uppercase text-[#0A0A0A] group-hover:text-[#B8965A] transition-colors"
      >
        Learn more
        <ArrowUpRight className="w-4 h-4 transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
      </Link>
    </motion.div>
  );
}
